var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMindMeSoloLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 35,
    viewBox: "0 0 120 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.634 8.11411L98.5201 16.2288L90.4062 8.11438L98.5206 0L106.634 8.11411Z",
    fill: "#556BB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.518 14.2238L111.403 22.3379L103.289 14.2238L111.404 6.10938L119.518 14.2238Z",
    fill: "#556BB8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16903_15173",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5,
    width: 92,
    height: 30
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.992188 34.4933V5.875H91.7306V34.4933H0.992188Z",
    fill: "#6AB644"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16903_15173)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.7227 11.3417L86.2555 16.8084L80.7891 11.3417L86.256 5.875L91.7227 11.3417Z",
    fill: "#556BB8"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8672 34.4866H29.0889V19.3711H24.8672V34.4866Z",
    fill: "#556BB8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9821 20.235C44.0241 21.0533 44.5458 22.4101 44.5458 24.3053V34.4838H40.2805V25.29C40.2805 24.4947 40.1692 23.8846 39.9469 23.459C39.5408 22.6826 38.7673 22.2946 37.6267 22.2946C36.2248 22.2946 35.263 22.863 34.741 24.0004C34.4706 24.6009 34.3349 25.3683 34.3349 26.3022V34.4838H30.1719V19.3961H34.2037V21.6008C34.7368 20.8241 35.2412 20.265 35.7164 19.9231C36.5696 19.313 37.6512 19.0078 38.9601 19.0078C40.599 19.0078 41.9393 19.4169 42.9821 20.235Z",
    fill: "#556BB8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6321 30.3787C56.2454 29.5466 56.5525 28.4697 56.5525 27.1475C56.5525 25.2988 56.0608 23.9768 55.0767 23.1813C54.473 22.7008 53.7715 22.4604 52.9733 22.4604C51.7573 22.4604 50.8675 22.8971 50.2974 23.771C49.728 24.6446 49.443 25.7283 49.443 27.0227C49.443 28.4188 49.733 29.5351 50.3123 30.3718C50.8916 31.2085 51.7671 31.6269 52.9441 31.6269C54.1221 31.6269 55.0185 31.2109 55.6321 30.3787ZM54.6095 19.6103C55.3585 20.0127 55.9679 20.5697 56.4351 21.2816V14.0703H60.6568V34.4833H56.6099V32.3895C56.0162 33.2862 55.3394 33.938 54.5803 34.345C53.8209 34.7516 52.8763 34.9551 51.748 34.9551C49.8908 34.9551 48.3258 34.2408 47.0548 32.8123C45.7838 31.3841 45.1484 29.5513 45.1484 27.314C45.1484 24.7346 45.774 22.7053 47.0258 21.2261C48.2769 19.7471 49.9492 19.0074 52.038 19.0074C53.0022 19.0074 53.8591 19.2082 54.6095 19.6103Z",
    fill: "#556BB8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_16903_15173",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 18,
    width: 40,
    height: 17
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.721 34.9876H61.6016V18.9727H100.721V34.9876Z",
    fill: "#909190"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_16903_15173)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5418 19.4274C82.2236 19.6864 82.8417 20.1395 83.3971 20.7863C83.8447 21.3136 84.1459 21.9606 84.3024 22.728C84.3996 23.2366 84.4482 23.9809 84.4482 24.9605L84.4192 34.4874H80.1537V24.8635C80.1537 24.2903 80.0562 23.8189 79.8618 23.4491C79.491 22.7463 78.8099 22.3952 77.817 22.3952C76.6677 22.3952 75.8738 22.848 75.435 23.7541C75.2116 24.2348 75.0998 24.8125 75.0998 25.4875V34.4874H70.9072V25.4875C70.9072 24.5908 70.8095 23.9389 70.6145 23.5323C70.2644 22.8018 69.5778 22.4366 68.5557 22.4366C67.3671 22.4366 66.5681 22.8018 66.1593 23.5323C65.9357 23.9485 65.8233 24.5679 65.8233 25.3905V34.4874H61.6016V19.3998H65.6485V21.6044C66.1649 20.819 66.6512 20.2593 67.1097 19.9268C67.9177 19.335 68.9645 19.0391 70.2496 19.0391C71.4666 19.0391 72.451 19.2935 73.2009 19.8017C73.8046 20.2734 74.262 20.879 74.5741 21.6185C75.1186 20.7308 75.7957 20.0792 76.604 19.6633C77.4608 19.247 78.4157 19.0391 79.4671 19.0391C80.1683 19.0391 80.8597 19.1687 81.5418 19.4274Z",
    fill: "#909190"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9766 14.5273L28.2577 18.2462L24.5391 14.5273L28.258 10.8086L31.9766 14.5273Z",
    fill: "#556BB8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6811 19.2402C21.3557 19.5019 21.968 19.9599 22.5172 20.6136C22.9608 21.1465 23.26 21.8005 23.4137 22.5761C23.51 23.0902 23.5586 23.8425 23.5586 24.8326L23.5294 34.4616H19.308V24.7346C19.308 24.1552 19.2112 23.6787 19.0182 23.305C18.6517 22.5946 17.9774 22.2397 16.9944 22.2397C15.8568 22.2397 15.0712 22.6974 14.6377 23.6132C14.4158 24.0991 14.3051 24.683 14.3051 25.3652V34.4616H10.1554V25.3652C10.1554 24.4589 10.0592 23.8 9.86596 23.389C9.51919 22.6507 8.83932 22.2816 7.82739 22.2816C6.65142 22.2816 5.86138 22.6507 5.45625 23.389C5.23435 23.8097 5.12393 24.4358 5.12393 25.2672V34.4616H0.945312V19.2122H4.94989V21.4405C5.46098 20.6466 5.94288 20.081 6.39587 19.7449C7.19642 19.1467 8.23227 18.8477 9.50499 18.8477C10.7096 18.8477 11.6829 19.1048 12.4256 19.6184C13.0229 20.0952 13.4759 20.7073 13.7843 21.4547C14.3243 20.5575 14.9942 19.899 15.794 19.4785C16.6421 19.0579 17.5867 18.8477 18.6281 18.8477C19.3222 18.8477 20.0065 18.9787 20.6811 19.2402Z",
    fill: "#556BB8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.2795 23.0016C89.6981 23.5818 89.332 24.3673 89.1834 25.3589H96.2737C96.1991 24.3017 95.8339 23.4996 95.1776 22.9523C94.5214 22.405 93.7079 22.1312 92.7371 22.1312C91.6801 22.1312 90.8616 22.4213 90.2795 23.0016ZM96.4368 19.5614C97.5352 20.0373 98.4419 20.7883 99.1572 21.8144C99.8017 22.7192 100.22 23.7689 100.411 24.9633C100.522 25.6626 100.567 26.6705 100.547 27.9859H89.0818C89.1461 29.5136 89.6952 30.5846 90.7277 31.1996C91.3571 31.5816 92.1134 31.7724 92.9976 31.7724C93.9353 31.7724 94.6973 31.5395 95.2832 31.0739C95.6025 30.8223 95.8851 30.473 96.1298 30.0258H100.332C100.221 30.9296 99.7126 31.847 98.8059 32.7784C97.396 34.2595 95.4221 35 92.8847 35C90.7894 35 88.941 34.3754 87.3395 33.1263C85.7379 31.877 84.9375 29.8444 84.9375 27.0286C84.9375 24.3903 85.6602 22.3675 87.106 20.9595C88.5519 19.5515 90.4283 18.8477 92.7347 18.8477C94.1055 18.8477 95.3386 19.0858 96.4368 19.5614Z",
    fill: "#909190"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMindMeSoloLogo);
export default __webpack_public_path__ + "static/media/mindMe-solo-logo.9b824823e9d62728f44af6cfea882a07.svg";
export { ForwardRef as ReactComponent };